import { ListItem } from './lists.model';

export class ARConsoleFormatType extends ListItem {}

export class ARConsoleVersion extends ListItem {
  consoleType: ARConsoleType;
  consoleFormatType: ARConsoleFormatType;
}

export class ARConsoleType extends ListItem {}

export class ARFertilizerType extends ListItem {}

export class ARConsoleModulationType extends ListItem {}
